import React from "react";

/**
 * RAYTECH Advisory — bold "R" mark with cybersecurity motif.
 * The R is anchored in a square; vertical scanlines + a corner shield notch
 * subtly reference cyber/security imagery without being literal.
 */
const RaytechLogo = ({ size = 38, variant = "dark" }) => {
  const ink = variant === "light" ? "#FFFFFF" : "#0F172A";
  const accent = variant === "light" ? "#3B82F6" : "#1E3A8A";
  const id = `mask-${variant}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="RAYTECH Advisory"
    >
      <defs>
        <mask id={id}>
          <rect width="40" height="40" fill="white" />
          {/* scan lines (cyber motif) */}
          <rect x="0" y="9" width="40" height="0.6" fill="black" />
          <rect x="0" y="19" width="40" height="0.6" fill="black" />
          <rect x="0" y="29" width="40" height="0.6" fill="black" />
        </mask>
      </defs>

      {/* Solid ink square */}
      <rect width="40" height="40" fill={ink} mask={`url(#${id})`} />

      {/* Top-right corner shield notch (accent) */}
      <path d="M40 0 L40 10 L30 0 Z" fill={accent} />

      {/* Bold R letterform */}
      <path
        d="M11.5 30 V11 H22.2 C25.4 11 28 13.4 28 16.5 C28 19 26.3 21.1 24 21.8 L28.5 30 H24.6 L20.5 22.2 H15.5 V30 Z M15.5 18.6 H21.7 C23.1 18.6 24.1 17.7 24.1 16.5 C24.1 15.3 23.1 14.4 21.7 14.4 H15.5 Z"
        fill="#FFFFFF"
      />

      {/* Bottom-left accent square (cyber pixel) */}
      <rect x="2" y="34" width="4" height="4" fill={accent} />
    </svg>
  );
};

export default RaytechLogo;
